import ajax from "@/lib/ajax";

// 查询转科转院患者列表
export async function QueryPDTransferList(payload: any) {
    let res = await ajax.post(`/api/services/app/PDTransfer/QueryPDTransferList`, payload);
    return res.data.result;
}


// WEBPACK FOOTER //
// ./src/api/pdTransferAndChangeBed/pdTransfer/index.ts